import { render, staticRenderFns } from "./RDPV26.vue?vue&type=template&id=5598523a&scoped=true"
import script from "./RDPV26.vue?vue&type=script&lang=js"
export * from "./RDPV26.vue?vue&type=script&lang=js"
import style0 from "./RDPV26.vue?vue&type=style&index=0&id=5598523a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5598523a",
  null
  
)

export default component.exports